<template>
  <!-- <div class="echarts-contain"> -->
    <div :id="id" class="o-echarts"></div>
    <!-- <div id="echarts_only_read_id" ref="echarts_only_read_id" class="o-echarts"></div> -->
  <!-- </div> -->
</template>

<script>
import echarts from "echarts";
export default {
  name: "doubleLineCharts",
  props: {
    doubleData: Array,
  },
  data() {
    return {
      id: "echarts_" + new Date().getTime() + Math.floor(Math.random() * 1000),
      // id:'echarts_only_read_id',
      echartObj: null,
      option: {
        legend: {
          show: true,
          data: ["考核分", "排名"],
          type: "plain",
          orient: "horizontal",
        //   y:'bottom',
          bottom: '14',
          itemGap: 35,
        },
        grid:{
            bottom: '15%',
            left:'15',
            right: '20',
            containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            z: 1, // 竖线在圆圈后面
            label: {
              backgroundColor: "rgba(0,0,0,0)",
              color: "black",
            },
          },
          // formatter:function(param){
          //     return '<div style=" "> '+ param.name + "<br>" + param.value + "<br>"
          //         '</div>';
          // }
        },

        calculable: true,
        dataZoom: [] ,
        // dataZoom: [
        //   {
        //     type: "inside",
        //     start: 0,
        //     end: 50,
        //     zoomLock: true,
        //     orient: 'horizontal'
        //   },
        // ],

        yAxis: [
          {
            type: "value",
            name: "考核分",
            nameTextStyle: {
              fontSize: 10,
              color: "#999999",
            },
            // 网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#999999",
                width: 0.5,
                type: "solid",
              },
            },
            // 默认以千分位显示，不想用的可以在这加一段
            axisLabel: {
              // 调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              textStyle: {
                color: "#999999",
              },
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return Number(value).toFixed(0);
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            min: 0,
            max: this.getLeftLine(),
            minInterval: 1,
            splitNumber: this.getRightLine() - 1,
            interval: this.getLeftLine() / (this.getRightLine() - 1),
          },
          {
            type: "value",
            name: "排名",
            nameLocation: "start",
            nameTextStyle: {
              fontSize: 10,
              color: "#999999",
            },
            // 网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: "#999999",
                width: 0.5,
                type: "solid",
              },
            },
            // 默认以千分位显示，不想用的可以在这加一段
            axisLabel: {
              // 调整左侧Y轴刻度， 直接按对应数据显示
              show: true,
              textStyle: {
                color: "#999999",
              },
              showMinLabel: true,
              showMaxLabel: true,
              formatter: function (value) {
                return Number(value).toFixed(0);
              },
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            min: 1,
            max: this.getRightLine(),
            splitNumber: this.getRightLine() - 1,
            interval: 1,
            minInterval: 1,
            inverse: true,
          },
        ],
        series: [],
      },
    };
  },
  beforeDestroy(){
    if(this.echartObj){
     this.echartObj.dispose();
     this.echartObj = null;
      // this.echartObj.clear();
    }
  },
  mounted() {
    this.echartObj = echarts.init(document.getElementById(this.id), null,  {renderer: 'svg'});
    // echarts.registerMap('yunnan', JSON);
    this.echartObj.setOption(this.setSeriesData(), true);
    //  this.$nextTick( ()=>{
    //       this.echartObj.setOption(this.setSeriesData(), true);
    //     })
  },
  methods: {
    getAvecount(){
      // 计算 折线图  百分比显示
      if(this.doubleData && this.doubleData.length > 0){

        let mathzhi = Math.round(4 / this.doubleData.length * 100);
        if(mathzhi >= 10 && mathzhi < 20){
          console.log('-----数据百分比:', mathzhi+'------'+ 10);
           return 10
        }else if(mathzhi >= 20 && mathzhi < 30){
          console.log('-----数据百分比:', mathzhi+'------'+ 20);
          return 25;
        }else if(mathzhi >= 30 && mathzhi < 40){
          console.log('-----数据百分比:', mathzhi+'------'+ 30);
          return 30
        }else if(mathzhi >= 40 && mathzhi < 50){
          console.log('-----数据百分比:', mathzhi+'------'+ 40);
          return 40
        }else if(mathzhi >= 50 && mathzhi < 60){
          console.log('-----数据百分比:', mathzhi+'------'+ 50);
           return 50;
        }else if(mathzhi >= 60 && mathzhi < 70){
          console.log('-----数据百分比:', mathzhi+'------'+ 60);
          return 60
        }else if(mathzhi >= 70 && mathzhi < 80){
          console.log('-----数据百分比:', mathzhi+'------'+ 70);
          return 70
        }else if(mathzhi >= 80 && mathzhi < 90){
          console.log('-----数据百分比:', mathzhi+'------'+ 80);
          return 80
        }else if(mathzhi >= 90 && mathzhi < 100){
          console.log('-----数据百分比:', mathzhi+'------'+ 90);
          return 90
        }else{
          return mathzhi
        }
        return Math.round(4 / this.doubleData.length * 100)
      }
    },
    getLeftLine() {
      // var data1 = [35, 15, 8, 12, 11, 6, 3, 0, 0, 2, 0, 20];
      let data1 = [];
      // console.log('----this.doubleData:', this.doubleData);
      if (this.doubleData && this.doubleData.length > 0) {
        for (let i = 0; i < this.doubleData.length; i++) {
          data1.push(this.doubleData[i].left);
        }
      }
      return this.calLeftMax(data1);
    },
    getRightLine() {
      let data2 = [];
      // var data2 = [1, 1, 2, 4, 2, 1, 3, 6, 6, 6, 2, 1];
      if (this.doubleData && this.doubleData.length > 0) {
        for (let i = 0; i < this.doubleData.length; i++) {
          data2.push(this.doubleData[i].right);
        }
      }
      return this.calRightMax(data2);
    },
    // 左轴计算最大值
    calLeftMax(arr) {
      let max = 0;
      // console.log('----数组:', arr);
      arr.sort(function (a, b) {
        return a - b;
      });
      max = arr[arr.length - 1];
      let maxint = Math.ceil(max / 9.5); // 不让最高的值超过最上面的刻度
      let maxval = maxint * 10; // 让显示的刻度是整数
      // console.log('----纵轴最大值：', maxval);
      return maxval;
    },
    // 左轴计算最大值
    calRightMax(arr) {
      let max = 0;
      arr.sort(function (a, b) {
        return a - b;
      });
      max = arr[arr.length - 1];
      return max;
    },
    getXaxisData() {
      // 填入横轴数据
      if (this.doubleData && this.doubleData.length > 0) {
        return this.doubleData.map((item) => {
          return item.xAxis;
        });
      }
    },
    getLeftSeriesData() {
      // 填入数据
      if ( this.doubleData && this.doubleData.length > 0) {
        return this.doubleData.map((item) => {
          return item.left;
        });
      }
    },
    getRightSeriesData() {
      // 填入数据
      if (this.doubleData && this.doubleData.length > 0) {
        return this.doubleData.map((item) => {
          return item.right;
        });
      }
    },
    setSeriesData() {
      this.setOptions( 'dataZoom', ( ()=>{
        if(this.doubleData && this.doubleData.length > 4 ){
           return [ {
            type: "inside",
            start: 0,
            end:  this.getAvecount(),
            zoomLock: true,
            orient: 'horizontal'
          } ]
        }else{
           return [
              {
                type: "inside",
                zoomLock: true,
                orient: 'horizontal',
              },
            ]
        }

      })() )
      this.setOptions( "xAxis", (() => {
          return {
            type: "category",
            showAllSymbol: true,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              show: true,
              // rotate: 45,
              textStyle: {
                color: "#999999",
              },
              // formatter: function(param, index) {
              //   console.log('-----坐标轴数据打印:', param);
              //   return param && param.replace('-', '/')
              // }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#999999",
              },
            },
            interval: 0,
            boundaryGap: false,
            data: this.getXaxisData(),
          };
        })()
      );
      this.setOptions( "series",(() => {
          return [
            {
              name: "考核分",
              type: "line",
            //   symbol: 'circle', // 拐点设置为实心
              symbolSize: 8, // 拐点大小
              smooth: false,
              yAxisIndex: 0,
              splitNumber: 4,
              min: 0,
              data: this.getLeftSeriesData(),
              itemStyle: {
                normal: {
                    color: 'rgba(54,179,116,1)', // 拐点颜色
                    borderColor: 'rgba(54,179,116,1)', // 拐点边框颜色
                    borderWidth: 2, // 拐点边框大小
                    emphasis: {
                        color: 'rgba(54,179,116,1)'// hover拐点颜色定义
                    }
                }
              },
              lineStyle: {
                normal: {
                    color: 'rgba(54,179,116,1)'
                }
              },
              areaStyle: {
                normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: 'rgba(54,179,116,1)' },
                        { offset: 1, color: 'rgba(54,179,116,0)' }
                    ])
                }
              },
              axisLabel:{
                formatter: function(value){
                  console.log('坐标值：',value)
                  return Number(value)
                }
              }
            },
            {
              name: "排名",
              type: "line",
            //   symbol: 'circle', // 拐点设置为实心
              symbolSize: 8, // 拐点大小
              splitNumber: 4,
              smooth: false,
              yAxisIndex: 1,
              min: 0,
              data: this.getRightSeriesData(),
              itemStyle: {
                normal: {
                    color: '#FF8C19', // 拐点颜色
                    borderColor: '#FF8C19', // 拐点边框颜色
                    borderWidth: 2, // 拐点边框大小
                    emphasis: {
                        color: '#FF8C19'// hover拐点颜色定义
                    }
                }
              },
              lineStyle: {
                normal: {
                    color: '#FF8C19'
                }
              },
              axisLabel:{
                formatter: function(value){
                  return Number(value)
                }
              }
            },
          ];
        })()
      );
      console.log("this.optionsssssss:", this.option);
      return this.option;
    },
    setOptions(objKey, objVal) {
      if ( this.option[objKey] && typeof this.option[objKey] === "object" && !Array.isArray(this.option[objKey]) ) {
        this.option[objKey] = Object.assign(this.option[objKey], objVal);
      } else {
        this.option[objKey] = objVal;
      }
      this.$set(this.option, objKey, this.option[objKey]);
    },
  },
};
</script>

<style lang="less" scoped>
.echarts-contain {
  width: 100%;
  height:100%;
}
.o-echarts {
    width: 100%;
    height: 100%;
  }
</style>
